export default __webpack_public_path__ + "static/media/camera.fda4555b.svg";